import { render, staticRenderFns } from "./FakeInputField.vue?vue&type=template&id=6a2132fc&scoped=true"
import script from "./FakeInputField.vue?vue&type=script&lang=js"
export * from "./FakeInputField.vue?vue&type=script&lang=js"
import style0 from "./FakeInputField.vue?vue&type=style&index=0&id=6a2132fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2132fc",
  null
  
)

export default component.exports